module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event3-a998797639325091aa287f135b6085ee.jpg";